import { useAtom } from 'jotai'

import { checkLoginSettingStore } from 'src/stores'

export const useCheckLoginSettingStore = () => {
  const [checkLoginSettingStoreValue, setCheckLoginSettingStoreValue] = useAtom(
    checkLoginSettingStore.state
  )

  return {
    checkLoginSettingStoreValue,
    setCheckLoginSettingStoreValue,
  }
}
